import { motion } from 'framer-motion';
import React from 'react';
import { FontAwesomeConfigurations } from '../../../../utils/Configuration/FontAwesomeConfiguration';
interface ProfileContainerProps {
  collapsedStates;
  setCollapsedStates;
  containerRef;
  onBlur;
}
const ProfileContainer: React.FC<ProfileContainerProps> = ({ ...props }) => {
  const handleOnCollapse = position => {
    const updatedCollapsedState = props.collapsedStates.map((item, index) => (index === position ? !item : item));
    props.setCollapsedStates(updatedCollapsedState);
  };

  const profileMenuItems = CrowdHub_App.CONFIG.NAVIGATION.find(element => {
    return element.as == 'navigate.profile';
  });

  return (
    <div className="profile_container">
      <div className={`header ${props.collapsedStates[0] ? 'visible' : ''}`} onClick={e => handleOnCollapse(0)}>
        Profile
        <i className={`collapse_icon ${FontAwesomeConfigurations.ICON_MINUS} fa-fw`} />
        <i className={`expand_icon ${FontAwesomeConfigurations.ICON_CHEVRON_DOWN} fa-fw`} />
      </div>
      <motion.div
        className="dropdown_items_container"
        variants={dropdown}
        initial={`hidden`}
        animate={props.collapsedStates[0] ? 'visible' : 'hidden'}
        style={{ y: 12 }}
        ref={props.containerRef}
      >
        {profileMenuItems.data?.tabs.map((tab, index) => {
          if (App.CORDOVA == false || !tab.hideOnApp) {
            return (
              <button
                key={tab.id}
                className="dropdown_item"
                onClick={e => {
                  let url = App.INSTANCE.appRouter.generate('navigate.profile', { tab: tab.id });
                  App.INSTANCE.route(url);
                  props.onBlur();
                }}
                role="link"
                aria-label={tab.name}
                tabIndex={0}
                style={{ border: 'none' }}
              >
                <div className="icon">
                  <i className={FontAwesomeConfigurations[tab.icon]}></i>
                </div>
                <div className="text">{tab.name}</div>
              </button>
            );
          }
        })}
      </motion.div>
    </div>
  );
};

const dropdown = {
  hidden: {
    opacity: 0,
    transition: { duration: 0.15 },
    display: 'none',
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.15 },
    display: 'flex',
  },
};

export default ProfileContainer;
